import React from 'react';
import { Reveal } from '../Reveal';
import { SectionHeading } from '../SectionHeading';
import { selectedTransactions, accents } from '../../data/site';
export function SelectedTransactions() {
  return <section className="boardroom-light relative overflow-hidden py-24 lg:py-32" data-id="element-223" data-mp="2xf018zzb10v9">
      <div className="aurora" aria-hidden="true" data-id="element-224" data-mp="2sgyf266l0lfk" />
      <div className="pattern-lattice-dark absolute inset-0 opacity-40" aria-hidden="true" data-id="element-225" data-mp="2sg6urrifqa4l" />
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10" data-id="element-226" data-mp="2nj6rfocyzlh6">
        <SectionHeading eyebrow="Selected Executive Transactions" title="Deals led, programs built, organizations scaled." tone="dark" data-id="element-227" data-mp="2ii9aff3p4xh9" />

        <ol className="mt-14 space-y-px overflow-hidden border border-white/10 bg-white/10" data-id="element-228" data-mp="29hudfihddtxx">
          {selectedTransactions.map((item, index) => {
          const accent = accents[index % accents.length];
          return <Reveal as="li" key={item} delay={0.04} className="group relative flex gap-6 bg-navy-800/70 px-7 py-7 backdrop-blur-md transition-colors duration-500 hover:bg-navy-700/70 sm:px-10" data-id="element-229" data-mp="7riw1xdlu10h" data-mpi={index}>
                <span className="font-display text-2xl font-light leading-none" style={{
              color: accent
            }} aria-hidden="true" data-id="element-230" data-mp="2dqb74f2v821d">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <p className="max-w-4xl text-sm leading-relaxed text-slate-200 sm:text-[0.95rem]" data-id="element-231" data-mp="36h2xux15vyhb">{item}</p>
                <span className="absolute inset-y-0 left-0 w-1 origin-top scale-y-0 transition-transform duration-500 group-hover:scale-y-100" style={{
              backgroundColor: accent
            }} aria-hidden="true" data-id="element-232" data-mp="2wox71qmnbn3p" />
              </Reveal>;
        })}
        </ol>
      </div>
    </section>;
}